exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-custom-payment{border-radius:15px;padding:25px 20px;margin:0;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;color:hsla(0,0%,100%,.8)}.card-custom-payment,.card-custom-payment-right{display:-webkit-box;display:-ms-flexbox;display:flex}.card-custom-payment-right{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;gap:1px}.card-custom-payment-right-title{font-weight:500;font-size:22px}.card-custom-payment-right-subtitle{font-weight:300;font-size:15px}.bg-voided{background-color:#777777e5}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-576cd5d4","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/views/system/payments/components/card.vue
// module id = RJf6
// module chunks = 0